import Translations from "translations/types";

const REVERSE_SEARCH_PAGE_KEY = "reverse_search" as const;

const REVERSE_SEARCH_STEPS = {
  ADD_NEW: "add_new",
  SAVE: "save",
  TYPE_OF_PATIENT: "type_of_patient",
} as const;

export const REVERSE_SEARCH_PAGE = {
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  key: REVERSE_SEARCH_PAGE_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  steps: {
    [REVERSE_SEARCH_STEPS.ADD_NEW]: {
      intro: (t: Translations) => t.tours.reverseSearch.stepE.introCapacityMode,
      key: REVERSE_SEARCH_STEPS.ADD_NEW,
      position: "left",
      step: 3,
      title: (t: Translations) => t.tours.reverseSearch.stepE.title,
    },
    [REVERSE_SEARCH_STEPS.SAVE]: {
      intro: (t: Translations) => t.tours.reverseSearch.stepD.intro,
      key: REVERSE_SEARCH_STEPS.SAVE,
      position: "top",
      step: 2,
      title: (t: Translations) => t.tours.reverseSearch.stepD.title,
    },
    [REVERSE_SEARCH_STEPS.TYPE_OF_PATIENT]: {
      intro: (t: Translations) => t.tours.reverseSearch.stepC.intro,
      key: REVERSE_SEARCH_STEPS.TYPE_OF_PATIENT,
      position: "left",
      step: 1,
      title: (t: Translations) => t.tours.reverseSearch.stepC.title,
    },
  },
} as const;
